// 第一次進牌局：操作教學（只教操作，不教規則）與 iPhone 靜音提示
// 對應 docs/PRD-Freemium.md 第 9 節
//
// - 教學：怎麼出牌、怎麼吃碰槓胡、怎麼代打；看過一次就不再顯示
// - iPhone 開靜音時 Web Audio 不會出聲，第一次在 iPhone 上進牌局時提示
//
// === 使用圖片 ===
// 無 — 純程式繪製（DOM overlay，不經 Phaser）

import { showNotice } from './notice-toast';

const GUIDE_ID = 'mahjong-first-play-guide';
const GUIDE_SEEN_KEY = 'mahjongking.first-play-guide-seen';
const SOUND_HINT_KEY = 'mahjongking.ios-sound-hint-seen';
const GUIDE_Z_INDEX = '1960';
const CARD_MAX_WIDTH_PX = 640;
const TITLE_FONT_PX = 32;
const STEP_FONT_PX = 24;
const BUTTON_FONT_PX = 28;
const RED = '#a0322a';
const SOUND_HINT_DELAY_MS = 600; // 教學關掉後再提示靜音

const seen = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return true;
  }
};

const markSeen = (key: string): void => {
  try {
    localStorage.setItem(key, '1');
  } catch {
    /* 寫不進去頂多下次再看一次 */
  }
};

const isIOS = (): boolean => /iPhone|iPad|iPod/i.test(navigator.userAgent);

const maybeShowSoundHint = (): void => {
  if (!isIOS() || seen(SOUND_HINT_KEY)) return;
  markSeen(SOUND_HINT_KEY);
  showNotice('沒聽到聲音？\n請把手機側邊的靜音開關打開');
};

/** 正式牌局開始時呼叫；doubleTap 決定出牌說明的寫法。 */
export const maybeShowFirstPlayGuide = (doubleTap: boolean): void => {
  if (typeof document === 'undefined') return;
  if (seen(GUIDE_SEEN_KEY) || document.getElementById(GUIDE_ID)) {
    maybeShowSoundHint();
    return;
  }
  markSeen(GUIDE_SEEN_KEY);
  const overlay = document.createElement('div');
  overlay.id = GUIDE_ID;
  Object.assign(overlay.style, {
    position: 'fixed',
    inset: '0',
    zIndex: GUIDE_Z_INDEX,
    background: 'rgba(0, 0, 0, 0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  });
  const card = document.createElement('div');
  Object.assign(card.style, {
    background: '#fff8ec',
    maxWidth: `${CARD_MAX_WIDTH_PX}px`,
    borderRadius: '22px',
    padding: '22px 28px',
    color: '#3a2a1a',
    fontFamily: '"PingFang TC", "Microsoft JhengHei", system-ui, sans-serif',
    maxHeight: '92vh',
    overflowY: 'auto',
  });
  const title = document.createElement('div');
  title.textContent = '怎麼玩';
  Object.assign(title.style, {
    fontSize: `${TITLE_FONT_PX}px`,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '12px',
  });
  const steps = [
    doubleTap ? '① 輪到你時，點一下牌會放大，再點一下就打出去' : '① 輪到你時，點一下牌就打出去',
    '② 可以吃、碰、槓、胡的時候，右下角會出現大按鈕',
    '③ 不想自己打，按「代打」讓電腦幫你打完這一手',
    '④ 慢慢打沒關係，不會限時',
  ];
  const list = document.createElement('div');
  for (const step of steps) {
    const line = document.createElement('div');
    line.textContent = step;
    Object.assign(line.style, {
      fontSize: `${STEP_FONT_PX}px`,
      margin: '10px 0',
      lineHeight: '1.5',
    });
    list.append(line);
  }
  const ok = document.createElement('button');
  ok.textContent = '我知道了';
  Object.assign(ok.style, {
    display: 'block',
    margin: '16px auto 0',
    fontSize: `${BUTTON_FONT_PX}px`,
    padding: '14px 40px',
    borderRadius: '14px',
    border: 'none',
    background: RED,
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
  });
  ok.addEventListener('click', () => {
    overlay.remove();
    setTimeout(maybeShowSoundHint, SOUND_HINT_DELAY_MS);
  });
  card.append(title, list, ok);
  overlay.append(card);
  document.body.append(overlay);
};
